/* OREXAMP: Pflichtfelder des Wunschtextes an echte Varianten-ID binden.
   Fallback: Vorhandene Optionselemente lesen, falls der Variant-Picker zeitverzoegert aktualisiert. */
(function () {
  function update(root) {
    var form = root.closest('form');
    if (!form) return;
    var variant = form.querySelector('input[name="id"]');
    var id = variant && variant.value;
    var ids = root.getAttribute('data-custom-ids') || '';
    var picker = root.closest('.shopify-section')?.querySelector('variant-picker');
    var option = picker?.querySelector('select[name="options[Schriftzug]"]');
    var checked = picker?.querySelector('input[data-option-name="Schriftzug"]:checked');
    var selected = (option && option.value) || (checked && checked.value);
    var active = selected === 'Individueller Wunschtext' || (!selected && !!id && ids.includes('|' + id + '|'));
    var panel = root.querySelector('[data-orx-fields]');
    if (!panel) return;
    panel.hidden = !active;
    panel.querySelectorAll('textarea,input').forEach(function(input) {
      input.disabled = !active;
      if (input.type !== 'hidden') input.required = active;
    });
  }
  function syncAll() { document.querySelectorAll('[data-orx-nadine]').forEach(update); }
  function enqueue() {
    requestAnimationFrame(syncAll);
    setTimeout(syncAll, 100);
  }
  document.addEventListener('change', enqueue);
  document.addEventListener('variant:change', enqueue);
  document.addEventListener('shopify:section:load', enqueue);
  document.addEventListener('DOMContentLoaded', syncAll);
  if (document.readyState !== 'loading') syncAll();
  var observer = new MutationObserver(function(records) {
    if (records.some(function(record){ return record.target && record.target.matches && record.target.matches('input[name="id"]'); })) enqueue();
  });
  function observeInputs() {
    document.querySelectorAll('[data-orx-nadine]').forEach(function(root){
      var input = root.closest('form')?.querySelector('input[name="id"]');
      if(input) observer.observe(input,{attributes:true,attributeFilter:['value']});
    });
  }
  document.addEventListener('DOMContentLoaded', observeInputs);
  if (document.readyState !== 'loading') observeInputs();
})();